/**
 * Types for MeEndpoint.
 *
 * IMPORTANT: This file is imported by client-side code.
 * Do NOT import from @prisma/client or any server-only modules here.
 */
import { z } from 'zod';
import { Language, LanguageEnum } from '../../../utils/lang';
export { Language, LanguageEnum };

// Client-safe role enums (matching Prisma schema)
export const InternalRole = {
  InternalEmployeePlanning: 'InternalEmployeePlanning',
  InternalEmployeePlus: 'InternalEmployeePlus',
  InternalAdmin: 'InternalAdmin',
  InternalAdminPlus: 'InternalAdminPlus',
  InternalOwner: 'InternalOwner',
} as const;
export type InternalRole = (typeof InternalRole)[keyof typeof InternalRole];

export const InternalRoleEnum = z.enum([
  'InternalEmployeePlanning',
  'InternalEmployeePlus',
  'InternalAdmin',
  'InternalAdminPlus',
  'InternalOwner',
]);

export const CarrierRole = {
  CarrierDispatcher: 'CarrierDispatcher',
  CarrierDriver: 'CarrierDriver',
} as const;
export type CarrierRole = (typeof CarrierRole)[keyof typeof CarrierRole];

export const CarrierRoleEnum = z.enum(['CarrierDispatcher', 'CarrierDriver']);

export const CustomerRole = {
  CustomerAdmin: 'CustomerAdmin',
  CustomerUser: 'CustomerUser',
} as const;
export type CustomerRole = (typeof CustomerRole)[keyof typeof CustomerRole];

export const CustomerRoleEnum = z.enum(['CustomerAdmin', 'CustomerUser']);

export const MeResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  image: z.string().nullable(),
  role: InternalRoleEnum.nullable(),
  isInternal: z.boolean(),
  language: LanguageEnum,
  customers: z.array(
    z.object({
      id: z.number(),
      role: CustomerRoleEnum,
      customer: z.object({
        id: z.number(),
        name: z.string(),
        vatNumber: z.string().nullable(),
      }),
    }),
  ),
  carriers: z.array(z.object({ id: z.number(), name: z.string(), role: CarrierRoleEnum })),
  carrier: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable(),
  truck: z
    .object({
      id: z.string(),
      licensePlate: z.string(),
      name: z.string(),
    })
    .nullable(),
  createdAt: z.date(),
});

export type MeResponse = z.infer<typeof MeResponseSchema>;
